import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isFavourAward: window.pageInfo['award']['favour'] || false
    };
  },
  computed: {
    ...mapGetters(['isLogin', 'favourHasGift', 'roleId', 'letter'])
  },
  methods: {
    favourFn() {
      // 如果沒有發獎，就直接提示收藏
      if (!this.isFavourAward) {
        this.doFavour(this.letter.favourTip);
        return;
      }

      // 如果還沒進入遊戲，就提示要先進遊戲
      if (!(this.isLogin && this.roleId)) {
        this.doFavour(this.letter.h5_favour_login_get);
        return;
      }

      // 如果已經領過了，就提示已領
      if (this.favourHasGift) {
        this.doFavour(this.letter.h5_favour_has_gift);
        return;
      }
      this.doFavour();

      this.$store.dispatch('get_award', { giftType: 'like' }).then((res) => {
        // 如果领奖失败
        if (res.result == '0') {
          this.doFavour(this.letter.h5_get_gift_fault, true);
          return;
        }
        this.doFavour(this.letter.h5_favour_get_gift, true, true);
        this.$store.dispatch('get_award_state');

        try {
          globalConfig.statistics('favour_gift');
        } catch (e) {}
      });
    },
    doFavour(text, onlyAlert) {
      if (!onlyAlert) {
        let link = window.globalGetGotoLink({ link: window.location.href });
        console.log(link);
        try {
          window.external.addFavorite(link, window.pageInfo['page_title']);
        } catch (e) {
          try {
            window.sidebar.addPanel(window.pageInfo['page_title'], link, '');
          } catch (e) {}
        }
      }

      this.$nextTick(() => {
        if (text) {
          if (window.pageInfo.popup.common_popup) {
            this.$store.commit('updateCommonTips', text);
          } else {
            alert(text);
          }
        }
      });
    }
  }
};
